import style from './block.module.scss'
import apiFetch from '@wordpress/api-fetch';
import { useState } from 'react';

function Block({ successMsg }) {
    const [error, setError] = useState(null)
    const [success, setSuccess] = useState(false)
    const [email, setEmail] = useState('')

    const handleSubmit = (e) => {
        e.preventDefault()
        setError(null)
        if (email === ''){
            setError('Votre email est requis');
        } else {
            apiFetch({
            path: "smartfire/newsletter",
            method: 'POST',
            data: { email: email }}).then(res => {
                if(res) setSuccess(true)
                else setSuccess(false)
            }).catch((error) => {
                console.error(error)
                setError('Oups, une erreur est survenue. Contactez-nous.')
            });

        }
    }

    return (
        <div className={style.newsletter}>
            {success ?
                <p className={style.success} >{successMsg}</p> :
                (
                <form onSubmit={handleSubmit}>
                    <label htmlFor="newtsletter-contact">Recevez votre newsletter</label>
                    <div className={style.inputRow}>
                        <input type="email" name="newsletter-email" placeholder="exemple@gmail.com" id="newsletter-contact" onChange={(e) => setEmail(e.currentTarget.value)}/>
                        <button type="submit">Je m'inscris</button>
                    </div>
                    {error && <p className={style.error}>{error}</p>}
                </form>
            )}
        </div>
    )
}

export default Block;
